export default __webpack_public_path__ + "static/media/HEAD.7d9867a3.svg";